import styled, { css, gapSize, hoverFocus, rem, screenMobilePlusAndBigger, screenMobilePlusAndSmaller } from 'theme';
import borderRadius from 'theme/global/border-radius';
import boxShadow from 'theme/global/box-shadow';

export const Card = styled('div')`
  width: 100%;
  max-width: ${rem(512)};
  border-radius: ${borderRadius.base};
  box-shadow: ${boxShadow.section};
  background-color: var(--ref-color-blackwhite-white);
  margin: 0 auto;
  transform: translateY(${() => gapSize(-4)});
`;

export const PaymentOption = styled('button')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${() => gapSize(3)};

  background-color: var(--ref-color-blackwhite-white);
  width: 100%;
  height: ${rem(160)};
  border: var(--sys-border-width-sm) solid var(--ref-color-blackwhite-white);
  transition: 300ms ease-in-out;

  &:first-of-type {
    border-top-left-radius: ${borderRadius.base};
    border-top-right-radius: ${borderRadius.base};
    border-bottom: ${rem(1)} solid var(--ref-color-gray-20);
  }

  &:last-of-type {
    border-bottom-left-radius: ${borderRadius.base};
    border-bottom-right-radius: ${borderRadius.base};
  }

  ${() =>
    hoverFocus(css`
      cursor: pointer;
      background-color: var(--ref-color-gray-10);
      border-color: var(--ref-color-silver-60);
    `)}

  ${() =>
    screenMobilePlusAndSmaller(css`
      padding: 0 ${gapSize(2)};
      height: ${rem(140)};
    `)}
`;

export const PaymentOptionText = styled('div')`
  width: 100%;
  text-align: center;
`;

export const IconWrapper = styled('div')`
  min-width: ${rem(120)};
  text-align: center;

  ${screenMobilePlusAndSmaller(css`
    min-width: ${rem(100)};
  `)}
`;

const Iframe = styled('iframe')`
  border: none;
  height: 100%;
`;

export const IdealIframe = styled(Iframe)`
  width: 100%;
  margin-top: ${() => gapSize(2)};
  min-height: ${rem(200)};
`;

export const CreditcardIframe = styled(Iframe)`
  // TODO: check with proper account on SIT/UAT
  // inherits from previous Iframe style:
  // width: ${rem(320)};
  // max-width: 100%;
  // margin: 0 auto;

  height: ${rem(450)};
  width: ${rem(400)};

  // The by Ingenico provided iframe has a fixed width of 265px
  min-width: 265px;
  min-height: 117px;
`;

export const IframeWrapper = styled('div')`
  padding: ${() => gapSize(2)};
  display: flex;
  flex-direction: column;
  align-items: center;
  svg {
    width: ${rem(120)};
  }

  ${screenMobilePlusAndBigger(css`
    svg {
      width: ${rem(240)};
    }
  `)}
`;

export const ErrorContainer = styled('div')`
  padding: ${() => gapSize(2)};
`;
